/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui';

/* ++++++++++ --------------- app.filters : STYLES --------------- ++++++++++ */
export default {
    newstatus: {
      width: pxToEm(60),
      height: pxToEm(26),
      fontSize: pxToEm(12),
      padding: pxToEm(4),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: pxToEm(4),
      background: '#FCD639',
      color: '#000',
      borderRadius: pxToEm(8)
    }
};
